/* GA — lightweight Add to Cart handler for product-grid cards
   (.ga-products__add-form). These are plain Liquid {% form 'product' %}
   tags, not wrapped in Dawn's <product-form> custom element, so without
   this they submit as a real page POST and Shopify redirects to /cart —
   this intercepts the submit, adds via fetch, and stays on the page. */
document.addEventListener('submit', function (event) {
  var form = event.target.closest('.ga-products__add-form');
  if (!form) return;
  event.preventDefault();

  var button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;

  var originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding...';

  fetch(window.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    body: new FormData(form),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      if (data.status) {
        button.textContent = 'Error';
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
        return;
      }
      button.textContent = 'Added';
      gaQuickAddUpdateCartCount();
      setTimeout(function () {
        button.textContent = originalText;
        button.disabled = false;
      }, 1200);
    })
    .catch(function () {
      button.textContent = originalText;
      button.disabled = false;
    });
});

function gaQuickAddUpdateCartCount() {
  fetch(window.routes.cart_url + '.js')
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      document.querySelectorAll('[data-ga-cart-count]').forEach(function (el) {
        el.textContent = 'Cart (' + cart.item_count + ')';
      });
    })
    .catch(function () {});
}
